//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const SCHEDULER_MIN_WIDTH = 900;

// TODO PD-249084: Do we want to keep this value or change to design's value of 1440?
// 1453px allows for one more media item to be displayed and 1300 allows for one less
// 1440 leaves enough space for almost one more media item
export const SCHEDULER_MAX_WIDTH = 1300;
export const SCHEDULER_MIN_BREAKPOINT = 1250;
export const SCHEDULER_MAX_BREAKPOINT = 1730;

export const SCHEDULER_FORM_ACTION_ID = {
  SCHEDULE_POST: 'schedule-post',
  DRAFT_POST: 'draft-post',
} as const;

export const SchedulerDefaultsTooltip = {
  DefaultNotificationUser:
    'Choose a user to receive notifications for your posts by default.',
  DefaultPostTime: 'Choose a default time of day for your scheduled posts.',
} as const;

export const SameDimensionInfoCopy = `For carousel posts, all media must have the same dimensions. We'll
  automatically resize all media to match the first piece of media, or
  you can resize each on your own.`;

export const PINTEREST_RECOMMENDED_ASPECT_RATIO = 2 / 3;
export const PinterestNonRecommendedDimensionsInfoCopy = `For Pinterest images, we recommend using a 2:3 aspect ratio, or 1000 x 1500 pixels, to avoid your image being cropped.`;

// TODO PD-301906: Copy may change
export const TikTokResizingImagesCopy = `We’ve resized your images to meet TikTok’s requirements.`;

export const REELS_MEDIA_SECTION_ALERT_TEXT = {
  Manual: `For your Reel to appear on the Instagram Reels tab, it must be 5 to 90 seconds long with a 9:16 aspect ratio. Reels that do not fit these requirements can still be posted to your Reels and/or feed.`,
  Auto: `For your Reel to appear on the Instagram Reels tab, it must be 5 to 90 seconds long with a 9:16 aspect ratio. Reels that do not fit these requirements will still be automatically posted to your Reels and/or feed.`,
};

export const SchedulerFieldChangedBadgeTooltip = {
  Caption: 'This caption has not been copied to each platform.',
  PostTime: 'This post time has not been applied to each platform.',
};

export const SCHEDULER_DEFAULT_ERROR_TEXT =
  'Something went wrong when scheduling. Please try again or contact Bazaarvoice Support.';

export const SCHEDULER_SOCIAL_PLATFORM_NETWORK_ICON_SIZE = 20;

export const SMART_INPUT_AI_CAPTION_MENU_DISABLED_TOOLTIP =
  'You must enter some text for our AI to improve a caption.';
export const SMART_INPUT_AI_CAPTION_MENU_GENERATE_DISABLED_TOOLTIP =
  'You must include 1 image or video for our AI to generate a caption.';
